"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatTime = function (seconds) {
    var round = Math.round(seconds);
    var s = round % 60;
    var minutes = Math.round((round - s) / 60);
    var m = minutes % 60;
    var h = Math.round((minutes - m) / 60);
    return "" + (h ? h + ':' : '') + (m > 9 ? m : '0' + m) + ":" + (s > 9 ? s : '0' + s);
};
exports.default = formatTime;
